import React from 'react';

/** Catches any uncaught React render error and shows a friendly card
 *  instead of letting the whole page go blank. This is the safety net
 *  for production data quirks (null fields, legacy shapes, etc.). */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info?.componentStack);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (this.state.error) {
      return (
        <div data-testid="error-boundary" className="min-h-[40vh] flex items-center justify-center p-6">
          <div className="max-w-lg w-full rounded-2xl border border-rose-200 dark:border-rose-800/40 bg-rose-50 dark:bg-rose-900/20 p-6">
            <h2 className="text-lg font-bold text-rose-900 dark:text-rose-200 mb-2">Something went wrong on this page</h2>
            <p className="text-sm text-rose-700 dark:text-rose-300 mb-4">{String(this.state.error?.message || this.state.error)}</p>
            <div className="flex gap-2">
              <button
                onClick={this.reset}
                className="px-3 py-1.5 rounded-md bg-rose-600 hover:bg-rose-700 text-white text-sm"
              >Try again</button>
              <button
                onClick={() => { window.location.href = '/dashboard'; }}
                className="px-3 py-1.5 rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm"
              >Go to Dashboard</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
